export default __webpack_public_path__ + "static/157-ceb007209c4882eafa7b88dd783315c5.jpg";